<script>
import Vue from 'vue'
import WSelect from '../../Forms/WSelect/WSelect.vue'
import WButton from '../../WButton/WButton.vue'

export default Vue.extend({
    name: 'SelectCellEditor',
    components: {
        WSelect,
        WButton,
    },
    data () {
        return {
            inputValue: '',
            name: 'select',
            options: [],
            placeholder: 'Select option...',
            multiple: false,
            disabled: false,
        }
    },
    created () {
        const { value, values, colDef } = this.params
        const {
            name, placeholder, multiple, disabled,
        } = colDef
        this.inputValue = Array.isArray(value) ? value.map(String) : String(value)
        this.options = this.normalizeOptions(values)

        if (name) this.name = name
        if (placeholder) this.placeholder = placeholder
        if (multiple) this.multiple = multiple
        if (disabled) this.disabled = disabled
    },
    methods: {
        getValue () {
            return this.inputValue
        },
        isPopup () {
            return true
        },
        normalizeOptions (values) {
            return Object.keys(values).map(key => ({ key: values[key], label: values[key] }))
        },
        handleInput (value) {
            this.inputValue = value
        },
        handleClick (happy) {
            this.params.api.stopEditing()
        },
    },

    render (h) {
        return h(
            'div',
            {
                class: 'SelectCellEditor EditorPopup flex row-center-top',
            },
            [
                h(WSelect, {
                    props: {
                        name: this.name,
                        value: this.inputValue,
                        options: this.options,
                        placeholder: this.placeholder,
                        multiple: this.multiple,
                    },
                    on: {
                        input: this.handleInput,
                    },
                }),
                h(WButton, {
                    props: {
                        iconLeft: 'save',
                        iconSize: 16,
                    },
                    on: {
                        click: this.handleClick,
                    },
                }),
            ],
        )
    },
})
</script>
